import { render } from "./BookUserBox.vue?vue&type=template&id=63d8f002&ts=true"
import script from "./BookUserBox.vue?vue&type=script&lang=ts"
export * from "./BookUserBox.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__